import { CallApiOptions } from './api';

export const fetchBrandsCallOptions = (appId: number): CallApiOptions => ({
  method: 'GET',
  endpoint: `proxies/mobile/${appId}/brands`,
});



// WEBPACK FOOTER //
// ./src/services/brands.services.ts